import { injectGlobal } from 'emotion';
import LLCircularBoldWoff from "../assets/CircularXXWeb-Bold.woff";
import LLCircularBoldWoff2 from "../assets/CircularXXWeb-Bold.woff2";
import LLCircularMediumWoff from "../assets/CircularXXWeb-Medium.woff";
import LLCircularMediumWoff2 from "../assets/CircularXXWeb-Medium.woff2";
import LLCircularRegularWoff from "../assets/CircularXXWeb-Regular.woff";
import LLCircularRegularWoff2 from "../assets/CircularXXWeb-Regular.woff2";
function _tagged_template_literal_loose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
function _templateObject() {
  var data = _tagged_template_literal_loose(["\n    * {\n      box-sizing: border-box;\n    }\n    @font-face {\n      font-family: 'AxLLCircular';\n      src: url(", ") format('woff2'),\n        url(", ") format('woff');\n      font-weight: 400;\n      font-style: normal;\n    }\n    @font-face {\n      font-family: 'AxLLCircular';\n      src: url(", ") format('woff2'),\n        url(", ") format('woff');\n      font-weight: 500;\n      font-style: normal;\n    }\n    @font-face {\n      font-family: 'AxLLCircular';\n      src: url(", ") format('woff2'),\n        url(", ") format('woff');\n      font-weight: 700;\n      font-style: normal;\n    }\n  "]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
var fonts = () => {
  return injectGlobal(_templateObject(), LLCircularRegularWoff2, LLCircularRegularWoff, LLCircularMediumWoff2, LLCircularMediumWoff, LLCircularBoldWoff2, LLCircularBoldWoff);
};
export { fonts as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9udHMuanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
